import { render, staticRenderFns } from "./DialogTemplateWithFooterToolkit.vue?vue&type=template&id=079d0511"
import script from "./DialogTemplateWithFooterToolkit.vue?vue&type=script&lang=js"
export * from "./DialogTemplateWithFooterToolkit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports